(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cbd-app-install"] && !Shopify.designMode) return;
  try {
    (() => {
 const open=document.getElementById('cbd-app-open'), dialog=document.getElementById('cbd-app-dialog');
 if(!open||!dialog)return;
 const native=document.getElementById('cbd-app-native'), help=document.getElementById('cbd-app-instructions'), fallback=document.getElementById('cbd-app-fallback');
 const media=window.matchMedia('(display-mode: standalone)');
 let pending=null;
 const installed=()=>media.matches||navigator.standalone===true;
 const sync=()=>{const active=installed();if(active){open.textContent=open.dataset.installedLabel;pending=null;}help.hidden=active;native.hidden=active||!pending;document.getElementById('cbd-app-offline').hidden=navigator.onLine;};
 open.addEventListener('click',()=>{sync();dialog.showModal();});
 dialog.addEventListener('close',()=>open.focus());
 window.addEventListener('beforeinstallprompt',event=>{event.preventDefault();pending=event;sync();});
 window.addEventListener('appinstalled',()=>{pending=null;native.hidden=true;help.hidden=true;open.textContent=open.dataset.installedLabel;dialog.close();});
 window.addEventListener('online',sync);window.addEventListener('offline',sync);media.addEventListener('change',sync);
 native.addEventListener('click',async()=>{const event=pending;if(!event)return;pending=null;native.hidden=true;try{await event.prompt();const choice=await event.userChoice;if(choice.outcome==='accepted')dialog.close();}catch{fallback.hidden=false;}});
 sync();
})();
  } catch(e) { console.error(e); }
})();

})();
